import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Step } from '../../configurator/models/Step';

type TPayload = {
    steps: Step[];
};

type TInsurancePackages={
    packages:any[]
}

export type ConfigState ={
    steps?: Step[];
    imageSrcsetTemplate?:string;
    baseURLs?:Record<string,string>,
    lensPackages?:any,
    lensesData?:any
}

const initialState:ConfigState  = {
    
};

const configSlice = createSlice({
    name: 'config',
    initialState: initialState,
    reducers: {
        changeSteps: (state, { payload }: PayloadAction<TPayload>) => {
            state.steps=payload.steps;
        },
        changeOptions: (state, {payload}:PayloadAction<ConfigState>) => {
            return {...state,...payload};
        },
        changeLensPackages: (state, {payload}:PayloadAction<any>) => {
            return {...state,lensPackages:payload};
        },
        setInsurancePackage: (state,{payload}:PayloadAction<TInsurancePackages>)=>{
            if(state.lensesData && state.lensesData.packages){
                state.lensesData.packages= state.lensesData.packages.map((p)=>{
                    const findedByUpc= payload.packages.find(insPackage=>insPackage.lensPackage && insPackage.lensPackage.upc===p.lensPackage.upc);
                    if(findedByUpc)
                        return findedByUpc;
                    return p;
                })
            }
        }
    },
  });

export const configReducer = configSlice.reducer;
export const configActions = configSlice.actions;